import React, { createContext, useContext, useEffect, useState } from 'react';

export const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [layoutMode, setLayoutMode] = useState(localStorage.getItem('layoutMode') || 'sidebar');

  useEffect(() => {
    // Always set light mode
    document.documentElement.setAttribute('data-theme', 'light');
    localStorage.setItem('theme', 'light');
    
    // Ensure dark theme class is removed
    document.body.classList.remove('dark-theme');
  }, []);

  // Update body class for layout mode
  useEffect(() => {
    localStorage.setItem('layoutMode', layoutMode);
    if (layoutMode === 'sidebar') {
      document.body.classList.add('sidebar-mode');
    } else {
      document.body.classList.remove('sidebar-mode');
    }
  }, [layoutMode]);

  const value = {
    isDarkMode: false,
    theme: 'light',
    toggleTheme: () => {}, // Empty function for compatibility
    layoutMode,
    setLayoutMode
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
